import { CallType, callTypeFromCode } from './CallType'
import { dateOptionalFromJSONValue, stringFromJSONValue } from './parser'
import { prettyDate } from './PrettyDate'

export class AlertModel {
  public recordID: string
  public dateTime?: Date
  public callType: CallType
  public message: string
  public agencyID: string

  public constructor(
    recordID: string,
    dateTime: Date | undefined,
    callType: CallType,
    message: string,
    agencyID: string
  ) {
    this.recordID = recordID
    this.dateTime = dateTime
    this.callType = callType
    this.message = message
    this.agencyID = agencyID
  }

  public static modelFromJSON(json: any): AlertModel {
    return new AlertModel(
      stringFromJSONValue(json['ID']),
      dateOptionalFromJSONValue(json['EntryDateTime']),
      callTypeFromCode(json['PulsePointIncidentCallType']),
      stringFromJSONValue(json['Message']),
      stringFromJSONValue(json['AgencyID'])
    )
  }

  public formattedDateTime(timeZone: string | undefined, includeDate: boolean) {
    return prettyDate(this.dateTime, timeZone, timeZone !== undefined, includeDate)
  }

  public listIconURL() {
    return `/images/respond_icons/${this.callType.id.toLowerCase()}_list.png`
  }
}
